import axios from "axios";
import axiosInstance from "./axioInstance";
const controllerUrl = `${process.env.REACT_APP_API}/competition`

export async function loginApi(postData) {
    const response = await axios.post(
        `${process.env.REACT_APP_API}/auth/authenticate`,
        JSON.stringify(postData),
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    )

    return response;
}


export async function getUserInfo() {
    const response = await axiosInstance.get(`${process.env.REACT_APP_API}/auth/getuserinfo`)

    return response;
}


export const deleteAccount = async (accessToken) => {
  try {
    const response = await axios.post(
    `${process.env.REACT_APP_API}/user/deleteuser`,
      {
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`, // 🔑 send token in header
          "Content-Type": "application/json"
        }
      }
    );

    console.log("Account deleted:", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response:", error.response.data);
    } else {
      console.error("Error message:", error.message);
    }
    throw error;
  }
};


